export default "__VITE_ASSET__a77266f2__"